import { NgModule, OnInit } from '@angular/core';
import { Routes, RouterModule, Router } from '@angular/router';
import { UpplmRouteMainComponent } from './components/routeMainComponent';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';


const routes: Routes = [
    { path: 'upplm', component: UpplmRouteMainComponent },
    { path: 'locationdetails', component: UpplmRouteMainComponent },
    { path: 'placardlocation', component: UpplmRouteMainComponent },
    { path: 'contactdetails', component: UpplmRouteMainComponent },
    { path: 'placarddetails', component: UpplmRouteMainComponent },
    { path: 'pickupdetails', component: UpplmRouteMainComponent },
    { path: 'notificationdetails', component: UpplmRouteMainComponent },
    { path: 'locationpending', component: UpplmRouteMainComponent },
    { path: 'locationcreated', component: UpplmRouteMainComponent },
    { path: 'placardexists', component: UpplmRouteMainComponent },
    { path: 'placardpending', component: UpplmRouteMainComponent },
    { path: 'placardconfirmed', component: UpplmRouteMainComponent },
    { path: 'approve', component: UpplmRouteMainComponent },
    { path: 'approveconfirmed', component: UpplmRouteMainComponent },
    { path: 'dashboard', component: UpplmRouteMainComponent },
    { path: 'placardAddClientKeyConfirm', component: UpplmRouteMainComponent },
    { path: 'placardaddclientKey', component: UpplmRouteMainComponent },
    { path: 'placardexistsconfirmation', component: UpplmRouteMainComponent },
    //{ path: 'qvsummary', component: UpplmRouteMainComponent},
    { path: '', pathMatch: 'full', redirectTo: '/upplm' }, 
    { path: '**', component: UpplmRouteMainComponent}
];
@NgModule({
    imports: [BrowserAnimationsModule, RouterModule.forRoot(routes, { useHash: false, enableTracing: true })], //, { useHash: true, enableTracing: true }
    exports: [RouterModule]
})
export class AppRoutingModule {   
   
}